// src/pages/pengamatan/destrak/DestrakTableBody.jsx
import React from 'react';
import { TableBody, TableRow, TableCell, Checkbox } from '@mui/material';
import './css/DestrakTableBody.css';

const DestrakTableBody = ({ 
  orders, 
  selectedItems, 
  handleSelectItem, 
  loadingOrders 
}) => {
  return (
    <TableBody>
      {orders.length > 0 ? (
        orders.map((order) => (
          <TableRow key={order.id}>
            {/* Checkbox - Fixed */}
            <TableCell 
              padding="checkbox"
              className="destrak-table-body-cell fixed checkbox"
            >
              <Checkbox
                checked={selectedItems.includes(order.id)}
                onChange={() => handleSelectItem(order.id)}
              />
            </TableCell>
            
            {/* Status Pengamatan - Fixed */}
            <TableCell className="destrak-table-body-cell fixed status-pengamatan">
              {order.status_pengamatan || '-'}
            </TableCell>
            
            {/* Tanggal Pengamatan - Fixed */}
            <TableCell className="destrak-table-body-cell fixed tanggal-pengamatan">
              {order.tanggal_pengamatan || '-'}
            </TableCell>
            
            {/* Kolom lainnya yang tidak fixed */}
            <TableCell className="destrak-table-body-cell">{order.tanggal_forcing || '-'}</TableCell>
            <TableCell className="destrak-table-body-cell">{order.umur || '-'}</TableCell>

            {/* Lokasi - Fixed */}
            <TableCell className="destrak-table-body-cell fixed lokasi">{order.lokasi || '-'}</TableCell>
            <TableCell className="destrak-table-body-cell fixed plot">{order.plot || '-'}</TableCell>
            {/* Lokasi - Fixed */}

            <TableCell className="destrak-table-body-cell">{order.status || '-'}</TableCell>
            
            {/* Data Bibit */}
            <TableCell className="destrak-table-body-cell">{order.varietas || '-'}</TableCell>
            <TableCell className="destrak-table-body-cell">{order.kelas || '-'}</TableCell>
            <TableCell className="destrak-table-body-cell">{order.jenis || '-'}</TableCell>
            
            <TableCell className="destrak-table-body-cell">{order.awal_rawat || '-'}</TableCell>
            <TableCell className="destrak-table-body-cell">{order.no_sample || '-'}</TableCell>
            
            {/* Data dari data_entry.destrak_tanaman */}
            <TableCell className="destrak-table-body-cell">{order.size || '-'}</TableCell>
            <TableCell className="destrak-table-body-cell">{order.berat_tanaman || '-'}</TableCell>
            <TableCell className="destrak-table-body-cell">{order.berat_buah_crown || '-'}</TableCell>
            <TableCell className="destrak-table-body-cell">{order.berat_buah || '-'}</TableCell>
            <TableCell className="destrak-table-body-cell">{order.berat_crown || '-'}</TableCell>
            <TableCell className="destrak-table-body-cell">{order.diameter_buah || '-'}</TableCell>
            <TableCell className="destrak-table-body-cell">{order.panjang_buah || '-'}</TableCell>
            <TableCell className="destrak-table-body-cell">{order.panjang_crown || '-'}</TableCell>
            <TableCell className="destrak-table-body-cell">{order.panjang_pedangkel || '-'}</TableCell>
            <TableCell className="destrak-table-body-cell">{order.berat_pedangkel || '-'}</TableCell>
            <TableCell className="destrak-table-body-cell">{order.panjang_d_leaf || '-'}</TableCell>
            <TableCell className="destrak-table-body-cell">{order.lebar_d_leaf || '-'}</TableCell>
            <TableCell className="destrak-table-body-cell">{order.berat_d_leaf || '-'}</TableCell>
            <TableCell className="destrak-table-body-cell">{order.jumlah_d_leaf || '-'}</TableCell>
            
            {/* Data dari data_entry.jumlah_mata */}
            <TableCell className="destrak-table-body-cell">{order.kanan || '-'}</TableCell>
            <TableCell className="destrak-table-body-cell">{order.kiri || '-'}</TableCell>
            <TableCell className="destrak-table-body-cell">{order.atas || '-'}</TableCell>
            
            <TableCell className="destrak-table-body-cell">{order.size_buah || '-'}</TableCell>
          </TableRow>
        ))
      ) : (
        <TableRow>
          <TableCell 
            colSpan={34} // Diperbarui untuk menyesuaikan jumlah kolom
            align="center"
            className="no-data-cell"
          >
            {loadingOrders ? 'Memuat data...' : 'Tidak ada data destrak dengan status Approved.'}
          </TableCell>
        </TableRow>
      )}
    </TableBody>
  );
};

export default DestrakTableBody;